export function JPYFormat(number) {
  return new Intl.NumberFormat("ja-JP", {
    // style: "currency",
    // currency: "JPY",
  }).format(number)
}
